import React, { FC } from 'react';

import {
  Container,
  Layer,
  Title,
  Message,
  ListContainer,
  Button,
  ButtonsWrapper,
} from './styles';

interface AlertModalProps {
  fields: string[];
  handleOnClose: () => void;
}

const AlertModal: FC<AlertModalProps> = ({ fields, handleOnClose }) => {
  return (
    <>
      <Layer>
        <Container>
          <Title>Atenção</Title>
          {/* <Message>
            Ao mudar o período, os
            <b> cursos listados abaixo serão descartados </b>
            pois estão contemplados em outra automação nessa mesma data.
          </Message> */}
          <Message>Alguns campos precisam ser preenchidos antes:</Message>
          <ListContainer>
            {fields.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ListContainer>

          <ButtonsWrapper>
            <Button onClick={handleOnClose}>Continuar</Button>
          </ButtonsWrapper>
        </Container>
      </Layer>
    </>
  );
};

export default AlertModal;
